export type AwsAuthErrorMessageKey =
	| 'errorSendingNewCode'
	| 'expiredSession'
	| 'expiredSmsCode'
	| 'invalidSession'
	| 'invalidSignIn'
	| 'invalidSmsCode'
	| 'invalidPhoneNumber'
	| 'tooManyAttempts';

export type AwsAuthErrorMessageValue = { awsErrorMessage?: string; userErrorMessage: string };
export type AwsAuthErrorMessage = Record<AwsAuthErrorMessageKey, AwsAuthErrorMessageValue>;

const awsAuthErrorMessages: AwsAuthErrorMessage = {
	errorSendingNewCode: {
		awsErrorMessage: undefined,
		userErrorMessage: 'An error occurred while sending a new code. Please try again.',
	},
	expiredSession: {
		awsErrorMessage: 'Invalid session for the user, session is expired.',
		userErrorMessage: 'Session has expired, please sign in again.',
	},
	expiredSmsCode: {
		awsErrorMessage: undefined,
		userErrorMessage: 'This verification code has expired.',
	},
	invalidSession: {
		awsErrorMessage: 'Invalid session for the user.',
		userErrorMessage: 'Session has expired, please sign in again.',
	},
	invalidSignIn: {
		awsErrorMessage: undefined,
		userErrorMessage: 'This is an incorrect email and/or password. Try again.',
	},
	invalidSmsCode: {
		awsErrorMessage: undefined,
		userErrorMessage: 'There was a problem with the code entered, please try again.',
	},
	invalidPhoneNumber: {
		awsErrorMessage: undefined,
		userErrorMessage:
			'There was a problem with the phone number entered, please check it is correct and try again.',
	},
	tooManyAttempts: {
		awsErrorMessage:
			'Too many invalid credentials attempts. User temporarily locked. Please try again after few seconds.',
		userErrorMessage:
			'Too many invalid codes have been entered. Please try again in a few seconds.',
	},
};

export default awsAuthErrorMessages;
